import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, _params) => ({
    '@keyframes fadeOut': {
        '0%': { opacity: 1 },
        '100%': { opacity: 0 },
    },
    '@keyframes slideIn': {
        '0%': { opacity: 0, transform: 'translateY(10px)' },
        '100%': { opacity: 1, transform: 'translateY(0)' },
    },
    '@keyframes pulse': {
        '0%': { transform: 'scale(1)' },
        '50%': { transform: 'scale(1.05)' },
        '100%': { transform: 'scale(1)' },
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
    },
    fadeOut: {
        animation: '$fadeOut 0.3s ease-in-out forwards',
    },
    // Header Section
    headerSection: {
        backgroundColor: _params.headerBackground, // var(--purple)
        padding: theme.spacing(2, 6),
        animation: '$slideIn 0.4s ease-out',
        [theme.breakpoints.down('sm')]: {
            padding: spacing.small,
        },
    },
    headerContent: {
        display: 'flex',
        alignItems: 'center',
        gap: spacing.small,
        [theme.breakpoints.down('sm')]: {
            gap: spacing.xs,
        },
    },
    questionIcon: {
        width: spacing.medium,
        height: spacing.medium,
        color: _params.headerText,
        flexShrink: 0,
        [theme.breakpoints.up('sm')]: {
            height: spacing.large,
            width: spacing.large,
        },
    },
    questionText: Object.assign(Object.assign({}, (theme.isFlyingFlowers ? theme.typography.medium_bold : theme.typography.large_bold)), { color: _params.headerText, flex: 1, [theme.breakpoints.down('sm')]: Object.assign({}, (theme.isFlyingFlowers ? theme.typography.small_bold : theme.typography.medium_bold)) }),
    // Content Section
    contentSection: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        padding: theme.spacing(2, 6, 4, 6),
        flex: 1,
        backgroundColor: _params.contentBackground,
        overflow: 'auto',
        animation: '$slideIn 0.5s ease-out',
        [theme.breakpoints.down('sm')]: {
            padding: `${spacing.small}`,
        },
    },
    // Progress Section
    progressContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
    },
    progressText: Object.assign(Object.assign({}, theme.typography.xxs_regular), { color: theme.isFlyingFlowers ? colors.black[700] : colors.supplementary.black }),
    progressBarContainer: {
        display: 'flex',
        gap: '0px',
        height: '8px',
        width: '100%',
    },
    progressSegment: {
        flex: 1,
        backgroundColor: colors.supplementary.white,
        transition: 'background-color 0.3s ease',
    },
    progressSegmentActive: {
        backgroundColor: _params.headerBackground,
    },
    // Spacer
    spacer: {
        height: '8px',
    },
    // Answers Section
    answersContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
    },
    answerOption: {
        display: 'flex',
        alignItems: 'center',
        gap: spacing.small,
        padding: theme.spacing(2),
        backgroundColor: colors.supplementary.white,
        cursor: 'pointer',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        border: 'none',
        textAlign: 'left',
        width: '100%',
        transform: 'scale(1)',
        '&:hover': {
            opacity: 0.9,
            transform: 'scale(1.02)',
        },
        '&:focus': {
            outlineOffset: '2px',
        },
        '&:active': {
            transform: 'scale(0.98)',
        },
        [theme.breakpoints.down('sm')]: {
            padding: `${spacing.xs} ${spacing.small}`,
        },
    },
    answerSelected: {
        backgroundColor: _params.selectedOptionBackground,
        animation: '$pulse 0.4s ease-in-out',
        transform: 'scale(1.02)',
    },
    answerCheckContainer: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        flexShrink: 0,
    },
    answerCheck: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        backgroundColor: _params.contentBackground,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
    },
    answerLabel: {
        fontSize: '16px',
        fontWeight: 600,
        lineHeight: '24px',
        letterSpacing: '0.8px',
        color: _params.bodyText,
    },
    answerTextContainer: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
    },
    answerText: Object.assign(Object.assign({}, theme.typography.small_bold), { color: _params.bodyText }),
}));
export default useStyles;
